import { Container } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { useContext } from 'react';
import { Page } from 'components';
import { UserGroupContext, userGroupSchema } from './UserGroupContext';
import { UserGroupForm } from './components';


let NewTicket = () => {

    let { isLoading, saveUserGroup, userGroup } = useContext(UserGroupContext);

    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title="User Group"
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={userGroupSchema}
                    initialValues={userGroup}
                    onSubmit={(values, action) => {
                        saveUserGroup(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    <Form>
                        <UserGroupForm />
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default NewTicket;